<template>
  <div>
    <b-row>
      <b-col
        cols="12"
        class="mt-3 d-flex justify-content-center align-items-center ml-2"
      >
        <p>
          Reports are not enabled for this study. An example of the report tool
          is shown below. Click the
          <span class="info-icon-wrapper">
            <i
              class="mdi mdi-information-outline clickable mx-1"
              aria-hidden="true"
            />
          </span>
          icon to the right for more information about the report interface
        </p>
      </b-col>
    </b-row>
    <div class="text-center">
      <img :src="placeholderImageUrl" alt="Report placeholder" />
    </div>
  </div>
</template>

<script>
import { SETTINGS_KEYS } from '@/store';

export default {
  name: 'ReportsPlaceholderImage',
  props: {
    questionnaireReportImage: {
      type: [String, null],
      default: null,
    },
  },
  computed: {
    placeholderImageUrl: function () {
      const storePath = this.$store.getters.getSetting(
        SETTINGS_KEYS.ASSETS_STORE_URL
      );
      const imageName =
        this.questionnaireReportImage ||
        this.$store.getters.getSetting(SETTINGS_KEYS.REPORTS_PLACEHOLDER_NAME);
      if (!storePath || !imageName)
        return require('../../../../public/SampleReport.png');
      return `${storePath}/${imageName}`;
    },
  },
};
</script>

<style scoped lang="scss">
.info-icon-wrapper {
  position: relative;
  display: inline-block;
  width: 34px;
  .mdi {
    position: absolute;
    top: -20px;
  }
}
</style>
